function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgLiveScheduleBackground = function SvgLiveScheduleBackground(props) {
  return h("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1280,
    height: 720,
    viewBox: "0 0 1280 720"
  }, props), h("defs", null, h("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y1: 0.105,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, h("stop", {
    offset: 0,
    stopColor: "#181f26"
  }), h("stop", {
    offset: 1,
    stopColor: "#060709"
  }))), h("path", {
    fill: "url(#a)",
    d: "M0 0h1280v720H0z",
    "data-name": "Rectangle 30"
  }));
};
export default SvgLiveScheduleBackground;